import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { ACCESS_LEVEL_LABELS, CONFIG_SWITCHER_MIN_LEVEL, isSuperAdmin, userLevelAtLeast } from '../../constants/access-levels';
import { ConfigListEntry } from '../../shared/app-config.model';
import { ConfigService } from '../../services/config.service';
import { expandConfigKeysByCompanyKey, parseAllowedClientConfigKeysFromUser } from '../../utils/config-list-expand';
import { filterProductBrandsForSalesperson, showSalespersonBrandScope } from '../../utils/salesperson-brand-scope';
import { UsersService } from '../../services/users.service'
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { GlobalsService } from '../../services/globals.service'
import { InventoryService } from '../../services/inventory.service';
import { FormBuilder, Validators, ControlContainer, FormGroup, FormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Location } from '@angular/common'

@Component({
	selector: 'app-user-edit',
	templateUrl: './user-edit.component.html',
	styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {
	@Input() user: any;
	/** When true (e.g. user list modal), skip main-content/card shell — routed `/users/edit/:id` uses the full page layout. */
	@Input() suppressPageChrome = false;
	@Output() updated = new EventEmitter < any > ();
	title = 'edit users';

	userForm: FormGroup;
	salesForm: FormGroup;
	isSalesmanToggle = new FormControl(false);
	userdetails: any = [];
	locations: any = [];
	userlocations: any = [];
	usergroups: any = [];
	alllocations: any = [];
	yesno: any = [
		{ value: '0', name: 'No' },
		{ value: '1', name: 'Yes' }
	];

	grouplevels: any[] = [
		{ name: 'Default', value: '0' },
		{ name: 'Salesman', value: '1' },
		{ name: 'Sales Manager', value: '2' },
		{ name: 'Regional Manager', value: '3' },
	];

	accessLevels = ACCESS_LEVEL_LABELS;

	groups: any = [];

	formEditAllowed = [
		'userid',
		'password',
		'realname',
		'phone',
		'email',
		'defaultlocation',
		'fullaccess',
		'cancreatetender',
		'editinv',
		'dispatchadmin',
		'customeradmin',
		'user_group',
		'blocked',
		'empcode',
		'department',
		'salesman',
		'viewcost'
		//'phoneno',
	]
	salesmanEditAllowed = [
		'salesmancode',
		'salesmanname',
		'smantel',
		'smanfax',
		'commissionrate1',
		'breakpoint',
		'commissionrate2',
		'current',
		'chatid',
		'group_id',
		'group_level',
		'group_type',
		'username',
	];

	searchAvailableDevices = '';
	searchUserDevices = '';

	userid: any = '';
	color: any = 'blue';

	company_devices: any = [];
	user_devices: any = [];
	zones: any = [];
	deviceTypes = ['INVOICE', 'CREDIT', 'PICK', 'RECEIPT']
	selectedDeviceTypes: {
		[key: string]: string[]; // Key should be a combination of deviceID and machineName
	} = {};

	selectedPrintTypes: {
		[key: string]: string[]; // Key should be a combination of deviceID and machineName
	} = {};


	managers: any = [];
	filteredDeviceTypes: any = [];
	issalesman: false;
	salesman_data: any = false
	salespeople: any = [];
	govern_salespeople = new FormControl([])
	salespeopleArray: any = [];
	allowedUiConfigOptions: ConfigListEntry[] = [];
	hidePassword = true;

	brands: { manufacturer_id: number; name: string }[] = [];
	luxuryBrands: { manufacturer_id: number; name: string; granted: boolean }[] = [];

	constructor(
		private route: ActivatedRoute,
		private formBuilder: FormBuilder,
		private userService: UsersService,
		public router: Router,
		private location: Location,
		public globalSearchService: GlobalSearchService,
		private globalsService: GlobalsService,
		private inventoryService: InventoryService,
		private configService: ConfigService
	) {
		this.color = this.globalSearchService.getColor();

		this.salesForm = this.formBuilder.group({
			salesmancode: ['', Validators.required],
			salesmanname: ['', Validators.required],
			smantel: [''],
			smanfax: [''],
			commissionrate1: [''],
			breakpoint: [''],
			commissionrate2: [''],
			current: ['1'],
			chatid: [''],
			group_id: ['1'],
			group_level: ['0'],
			group_type: ['1'],
			username: [''],
			smanlogin: [''],
			smanpass: [''],
			smanaddr: [''],
			smancity: [''],
			smanstate: [''],
			smanzip: [''],
			smantab: [''],
			smancell: [''],
			smanemail: [''],
			access_level: ['0'],
			csremails: [''],
			manager: [''],
			viewcost: ['0'],
			assinged_salespeople: [],
			portal_manufacturer_ids: [[]],
			portal_default_manufacturer_id: [null],
		});
	}

	loadLuxuryBrands(salesmancode: string): void {
		this.luxuryBrands = [];
		if (!salesmancode) return;
		this.globalsService.getLuxuryManufacturers(salesmancode).subscribe((rows: any) => {
			this.luxuryBrands = Array.isArray(rows)
				? rows.map((r: any) => ({
						manufacturer_id: Number(r.manufacturer_id),
						name: String(r.name ?? '').trim(),
						granted: r.granted == 1 || r.granted === true,
				  }))
				: [];
		});
	}

	portalBrandLabel(manufacturerId: number): string {
		const row = this.brands.find((b) => b.manufacturer_id === manufacturerId);
		return row ? row.name : String(manufacturerId);
	}

	onPortalBrandsChange(): void {
		if (!this.salesForm) {
			return;
		}
		const ids = (this.salesForm.get('portal_manufacturer_ids')?.value || []) as number[];
		const defCtrl = this.salesForm.get('portal_default_manufacturer_id');
		const cur = defCtrl?.value != null && defCtrl.value !== '' ? Number(defCtrl.value) : null;
		if (cur != null && Number.isFinite(cur) && !ids.includes(cur)) {
			defCtrl?.setValue(ids.length ? ids[0] : null, { emitEvent: false });
		}
		if (!ids.length) {
			defCtrl?.setValue(null, { emitEvent: false });
		}
	}

	get canEditAllowedClientConfigs(): boolean {
		return userLevelAtLeast(this.globalSearchService.user.getValue(), CONFIG_SWITCHER_MIN_LEVEL);
	}

	get isMoovSetup(): boolean {
		const client = this.configService.getConfig()?.env?.client;
		return client === 'moov' || client === 'moov_sandbox';
	}

	get showSalespersonBrandScope(): boolean {
		return showSalespersonBrandScope(this.configService.getConfig());
	}

	private loadAllowedUiConfigOptions(): void {
		this.configService.loadAvailableConfigs().pipe(take(1)).subscribe(list => {
			const base = list || [];
			const editor = this.globalSearchService.user.getValue();
			if (!userLevelAtLeast(editor, CONFIG_SWITCHER_MIN_LEVEL)) {
				this.allowedUiConfigOptions = [];
				return;
			}
			const editorKeys = parseAllowedClientConfigKeysFromUser(editor?.user);
			if (!editorKeys.length) {
				this.allowedUiConfigOptions = isSuperAdmin(editor) ? base : [];
				return;
			}
			const expanded = expandConfigKeysByCompanyKey(editorKeys, base);
			const allow = new Set(expanded);
			this.allowedUiConfigOptions = base.filter((c) => allow.has(c.config));
		});
	}

	ngOnInit(): void {

		this.loadAllowedUiConfigOptions();

		if (this.showSalespersonBrandScope) {
			this.inventoryService.getItemManufacturer().subscribe((rows: any) => {
				this.brands = filterProductBrandsForSalesperson(rows);
			});
		}

		this.globalsService.getActiveSalesPeople().subscribe(results => {
			this.salespeople = results;
		});

		this.globalsService.getSalesManagers().subscribe((results: any) => {
			this.managers = results;
		});

		this.globalSearchService.zones.subscribe((results: any) => {
			this.zones = results;
		});

		this.route.params.subscribe(params => {
			if (params['id'] && params['id'] != '') {
				this.userid = params['id'];
				this.loadUser()
			} else {
				this.userid = this.user.userid;
				this.loadUser();
			}
		});
	}

	loadUser() {
		this.userService.getUser(this.userid).subscribe((user: any) => {
			this.user = user;
			this.userdetails = user;

			if (user.issalesman) {
				this.isSalesmanToggle.setValue(true);
				const data = {
					salesman: user.salesman
				}
				this.globalsService.getSalesPerson(data).subscribe(salesperson => {
					if (!salesperson?.salesmancode) {
						salesperson = {
							...(salesperson || {}),
							salesmancode: user.salesman,
							salesmanname: user.realname || '',
							username: user.userid || '',
							smanemail: user.email || '',
							smantel: user.phone || '',
							current: '1',
							group_id: '1',
							group_level: '0',
							group_type: '1',
							portal_manufacturer_ids: [],
							portal_default_manufacturer_id: null,
							assinged_salespeople: [],
						};
					}

					this.salesman_data = salesperson;
					this.salespeopleArray = salesperson.assinged_salespeople;

					if (salesperson.smanemail == '') {
						salesperson.smanemail = this.userForm.get('email').value
					}

					if (salesperson.username == '') {
						salesperson.username = this.userForm.get('userid').value
					}

					if (salesperson.smantel == '') {
						salesperson.smantel = this.userForm.get('phone').value
					}



					this.salesForm = this.formBuilder.group({
						salesmancode: [salesperson.salesmancode, Validators.required],
						salesmanname: [salesperson.salesmanname, Validators.required],
						smantel: [salesperson.smantel],
						smanfax: [salesperson.smanfax],
						commissionrate1: [salesperson.commissionrate1],
						breakpoint: [salesperson.breakpoint],
						commissionrate2: [salesperson.commissionrate2],
						current: [salesperson.current],
						chatid: [salesperson.chatid],
						group_id: [salesperson.group_id],
						group_level: [salesperson.group_level],
						group_type: [salesperson.group_type],
						username: [salesperson.username],
						smanlogin: [salesperson.smanlogin],
						smanpass: [salesperson.smanpass],
						smanaddr: [salesperson.smanaddr],
						smancity: [salesperson.smancity],
						smanstate: [salesperson.smanstate],
						smanzip: [salesperson.smanzip],
						smantab: [salesperson.smantab],
						smancell: [salesperson.smancell],
						smanemail: [salesperson.smanemail],
						access_level: [salesperson.access_level],
						csremails: [salesperson.csremails],
						manager: [salesperson.manager],
						viewcost: [salesperson.viewcost],
						assinged_salespeople: [salesperson.assinged_salespeople],
						portal_manufacturer_ids: [
							Array.isArray(salesperson.portal_manufacturer_ids)
								? salesperson.portal_manufacturer_ids.map((n: any) => Number(n)).filter((n: number) => n > 0)
								: [],
						],
						portal_default_manufacturer_id: [
							salesperson.portal_default_manufacturer_id != null && salesperson.portal_default_manufacturer_id !== ''
								? Number(salesperson.portal_default_manufacturer_id)
								: null,
						],
					});

					if(!this.isMoovSetup && this.salesman_data?.salesmancode != ''){
						this.loadLuxuryBrands(this.salesman_data.salesmancode)
					}
				});
			}

			const controls = [];
			const details = user;
			const formGroup: UntypedFormGroup = new FormGroup({});
			Object.keys(details).forEach(key => {
				if (this.formEditAllowed.includes(key)) {
					let value = (details[key]) ? details[key] : '';
					if (key === 'fullaccess') {
						value = String(value);
					}
					controls.push({ name: key, control: new FormControl(value, []) })
				}
			});
			controls.forEach(f => {
				formGroup.addControl(f.name, f.control, {})
			});

			formGroup.setControl('password', new FormControl(''));

			this.userForm = formGroup;
			this.userForm.get('userid')?.disable();
			if (this.canEditAllowedClientConfigs) {
				this.userForm.addControl('allowedUiConfigs', new FormControl(parseAllowedClientConfigKeysFromUser(user)));
			}
			this.userForm.addControl('notify_password_by_email', new FormControl(false));
			const data = { userid: this.user.userid }

			this.userService.getCompanyDevices(data).subscribe(cd => {
				this.company_devices = cd;
				this.user_devices = this.userService.getPrintSettings(this.user.userid);
				this.filteredDeviceTypes = this.company_devices;
			})

			this.userForm.get('salesman').valueChanges.subscribe(newValue => {
				if (this.isSalesmanToggle.value) {
					if (this.salesForm) {
						this.salesForm.get('salesmancode').setValue(newValue);
					}
				}

				if (newValue == '') {
					this.isSalesmanToggle.setValue(false);
				} else if (!this.isSalesmanToggle.value) {
					this.isSalesmanToggle.setValue(true, { emitEvent: false });
				}
			});

			this.isSalesmanToggle.valueChanges.subscribe((enabled) => {
				if (!enabled) {
					return;
				}
				const userid = String(this.userForm.get('userid')?.value ?? '').trim();
				let code = String(this.userForm.get('salesman')?.value ?? '').trim();
				if (!code && userid) {
					code = userid;
					this.userForm.get('salesman')?.setValue(code, { emitEvent: false });
				}
				if (!code || !this.salesForm) {
					return;
				}
				if (String(this.salesForm.get('salesmancode')?.value ?? '').trim() === '') {
					this.salesForm.patchValue({
						salesmancode: code,
						salesmanname: this.userForm.get('realname')?.value || '',
						username: this.userForm.get('userid')?.value || '',
						smanemail: this.userForm.get('email')?.value || '',
						smantel: this.userForm.get('phone')?.value || '',
					});
				}
			});

			});

	}

	getSelectedDeviceTypes(deviceID: string, machineName: string) {
		return this.selectedDeviceTypes[deviceID + '_' + machineName] || [];
	}

	updatePrintSettings(deviceID: string, machineName: string, deviceTypes: string[]) {
		const selectedDevice = this.user_devices.find(device =>
			device.deviceID === deviceID && device.machineName === machineName
		);

		if (selectedDevice) {
			this.userService.setPrintSetting(
				this.user.userid,
				selectedDevice.machineUser,
				selectedDevice.machineName,
				deviceID,
				deviceTypes
			);
		}
	}


	addUserDevice(device: any) {
		const payload = {
			userid: this.user.userid,
			deviceid: device.device_id,
			machinename: device.machine_name // Include both device_id and machine_name
		};

		this.userService.setPrintSetting(
			this.user.userid,
			device.machine_user,
			device.machine_name,
			device.device_id,
			this.selectedDeviceTypes[device.device_id + '_' + device.machine_name] // Use combined key
		);

		this.user_devices = this.userService.getPrintSettings(this.user.userid);
	}


	removeUserDevice(device: any) {
		const payload = {
			userid: this.user.userid,
			deviceid: device.deviceID,
			machinename: device.machineName // Include both device_id and machine_name
		};

		this.userService.deletePrintSetting(this.user.userid, device.deviceID, device.machineName);
		this.user_devices = this.userService.getPrintSettings(this.user.userid);
	}


	// Check if a device is already set up for a user
	isDeviceSetupForUser(deviceID: string) {
		const settings = JSON.parse(localStorage.getItem('printSettings')) || {};
		const userSettings = settings[this.user.userid] || [];
		return userSettings.some((device: any) => device.deviceID === deviceID);
	}

	back(): void {
		this.location.back()
	}

	generatePassword(): void {
		const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
		let pass = '';
		for (let i = 0; i < 6; i++) {
			pass += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		this.userForm.get('password')?.setValue(pass);
	}

	onSave($event) {}

	saveAll(): void {
		if (this.isSalesmanToggle.value) {
			this.saveSalesPerson();
		} else {
			this.updateUser();
		}
	}

	updateUser() {
		const payload: any = { ...this.userForm.getRawValue() };
		if (this.canEditAllowedClientConfigs && this.userForm.get('allowedUiConfigs')) {
			const keys = payload.allowedUiConfigs as string[] | undefined;
			delete payload.allowedUiConfigs;
			payload.allowed_client_configs = keys && keys.length ? JSON.stringify(keys) : null;
		} else {
			delete payload.allowedUiConfigs;
		}

		if (payload.notify_password_by_email && !String(payload.password || '').trim()) {
			this.globalSearchService.showNotification(
				'Enter or generate a password before choosing email notification.',
				'warning',
				'bottom',
				'right'
			);
			return;
		}

		this.userService.updateUser(this.user.userid, payload).subscribe(async (results) => {
			this.user.user = results;
			this.userForm.patchValue({ password: '', notify_password_by_email: false });
			this.globalSearchService.showNotification('Updated', 'success', 'bottom', 'right');
			this.updated.emit(results);

		});

	}

	getUserDevicesByPrintType(printType: string): any[] {
		return this.user_devices.filter(device => device.deviceTypes.includes(printType));
	}

	ngAfterViewInit() {

		this.globalsService.getAllLocations().subscribe(async details => {
			this.locations = details;
			this.alllocations = details;
		});

		this.userService.getUserGroups().subscribe(async groups => {
			this.usergroups = groups;
		});

	}

	updateLocations() {
		const data = {
			userid: this.userid,
			locations: this.user.locations
		};

		this.userService.updateUserLocations(data).subscribe(async (user: any) => {
			this.user = user;
			this.globalsService.getAllLocations().subscribe(async details => {
				this.locations = details;
				this.alllocations = details;
			});
			this.globalSearchService.showNotification('Modifed', 'success', 'bottom', 'left')
		});
	}



	hasDevice(deviceid: any): boolean {
		const devices: any[] = [];
		//
		// 		if (this.user) {
		// 			devices = this.user_devices.filter(loc => loc.device_id === deviceid);
		// 		}

		return devices.length > 0;
	}

	private refreshLoggedInSalesmanSessionIfSelfEdited(): void {
		const auth = this.globalSearchService.user.getValue();
		const u = auth?.user;
		if (!auth?.pass || !u?.userid || !u?.issalesman) {
			return;
		}
		if (String(u.userid ?? '') !== String(this.userid ?? '')) {
			return;
		}
		this.userService.getUser(u.userid).subscribe((profile: any) => {
			this.globalSearchService.mergeSessionUserProfile(profile);
		});
	}

	saveSalesPerson() {
		if (!this.salesForm) {
			return;
		}
		const code = String(this.salesForm.get('salesmancode')?.value ?? '').trim();
		const name = String(this.salesForm.get('salesmanname')?.value ?? '').trim();
		if (!code || !name) {
			this.salesForm.markAllAsTouched();
			this.globalSearchService.showNotification(
				'Salesperson code and name are required before saving.',
				'warning',
				'bottom',
				'right'
			);
			return;
		}

		this.updateUser();

		this.salesForm.get('assinged_salespeople')?.setValue(this.salespeopleArray);

		const raw = { ...this.salesForm.getRawValue() };
		const pids = Array.isArray(raw.portal_manufacturer_ids)
			? raw.portal_manufacturer_ids.map((n: any) => Number(n)).filter((n: number) => n > 0)
			: [];
		raw.portal_manufacturer_ids = pids;
		const pdf =
			raw.portal_default_manufacturer_id != null && raw.portal_default_manufacturer_id !== ''
				? Number(raw.portal_default_manufacturer_id)
				: null;
		raw.portal_default_manufacturer_id = pdf != null && Number.isFinite(pdf) && pids.includes(pdf) ? pdf : pids.length ? pids[0] : null;

		this.globalsService.saveSalesPerson(raw).subscribe({
			next: () => {
				this.refreshLoggedInSalesmanSessionIfSelfEdited();
				this.globalSearchService.showNotification('Salesperson saved', 'success', 'bottom', 'right');
				this.globalsService.getSalesPerson({ salesman: raw.salesmancode }).subscribe((sp: any) => {
					if (!this.salesForm || !sp?.salesmancode) {
						return;
					}
					const ids = Array.isArray(sp.portal_manufacturer_ids)
						? sp.portal_manufacturer_ids.map((n: any) => Number(n)).filter((n: number) => n > 0)
						: [];
					this.salesForm.patchValue({
						portal_manufacturer_ids: ids,
						portal_default_manufacturer_id:
							sp.portal_default_manufacturer_id != null && sp.portal_default_manufacturer_id !== ''
								? Number(sp.portal_default_manufacturer_id)
								: null,
					});
				});
			},
			error: (err: any) => {
				const msg =
					(typeof err?.error === 'string' && err.error) ||
					err?.error?.message ||
					err?.message ||
					'Could not save salesperson.';
				this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'right');
			},
		});
	}

	hasLocation(location: any) {
		//this.user becomes false when modalService closes
		let access = []

		if (this.user) {
			access = this.user.locations.filter(loc => {
				return loc.loccode == location;
			})
		};

		return (access.length > 0) ? true : false;
	}

	addUserLocation(loc: any) {
		const index = this.locations.indexOf(loc)
		this.locations.splice(index, 1);
		this.user.locations.push(loc)
	}

	addAllLocation(loc: any) {
		this.user.locations = this.locations;
	}
	getIsManager() {
		if (parseFloat(this.salesForm.get('group_level').value) > 1) {
			return true;
		}
		return false;
	}

	removeUserLocation(loc: any) {
		const index = this.user.locations.indexOf(loc);
		this.user.locations.splice(index, 1);
	}

	toggleCheckbox(value: string) {
		const index = this.salespeopleArray.indexOf(value);
		if (index === -1) {
			this.salespeopleArray.push(value);
		} else {
			this.salespeopleArray.splice(index, 1);
		}
	}

	searchDeviceTypes(search: string) {
		this.filteredDeviceTypes = this.deviceTypes.filter(type =>
			type.toLowerCase().includes(search.toLowerCase()));
	}

	filteredAvailableDevices() {
		return (this.company_devices || []).filter(device =>
			(device.machine_name?.toLowerCase().includes(this.searchAvailableDevices?.toLowerCase() || '') ||
				device.device_id?.toLowerCase().includes(this.searchAvailableDevices?.toLowerCase() || ''))
		);
	}

	filteredUserDevices() {
		return (this.user_devices || []).filter(device =>
			(device.machineName?.toLowerCase().includes(this.searchUserDevices?.toLowerCase() || '') ||
				device.deviceID?.toLowerCase().includes(this.searchUserDevices?.toLowerCase() || ''))
		);
	}


	onSubmit() {

	}
}